<template>
  <div class="pe-option-container" v-if="option">
    <div class="inputs-row">
      <PeInpunt v-model="areaCode" placeholder="Ingresá el area (sin 0)" type="tel" class="input-area"
        :class="[areaCode ? globalConfig.classes?.input : globalConfig.classes?.placeholder]"
        @update:modelValue="updateAnswer" />

      <PeInpunt v-model="phoneNumber" placeholder="Ingresá el número (sin 15)" type="tel" class="input-number"
        :class="[phoneNumber ? globalConfig.classes?.input : globalConfig.classes?.placeholder]"
        @update:modelValue="updateAnswer" />

    </div>
  </div>

  <span v-if="option.error" :class="['pe-error-msg', globalConfig.classes?.optionError]">{{ option.error }}</span>
</template>

<script setup>
import { inject, ref, watch } from 'vue';
import PeInpunt from '../Shared/PeInpunt.vue';

const props = defineProps({
  question: { type: Object, required: true },
});

const engine = inject('formEngine');
const globalConfig = inject('engineConfig');

const option = props.question.options.find(opt => opt.type.includes("contact_"));

const areaCode = ref("");
const phoneNumber = ref("");

// Lógica para sincronizar si viene un valor externo (precarga)
watch(() => option.value, (newVal) => {
  if (newVal && newVal.includes(" ")) {
    const parts = newVal.split(" ");
    if (parts.length >= 2) {
      areaCode.value = parts[0];
      phoneNumber.value = parts.slice(1).join("");
    }
  } else if (!newVal) {
    areaCode.value = "";
    phoneNumber.value = "";
  }
}, { immediate: true });

const updateAnswer = () => {
  if (areaCode.value || phoneNumber.value) {
    const fullValue = `${areaCode.value} ${phoneNumber.value}`;
    engine.setAnswer(props.question.id, option.id, fullValue);
  } else if (!areaCode.value && !phoneNumber.value) {
    engine.setAnswer(props.question.id, option.id, null);
  }
};
</script>

<style scoped>
.inputs-row {
  display: flex;
  width: var(--pe-contact-row-width, 100%);
  gap: var(--pe-contact-row-gp, 2vw);
}

.input-area {
  width: var(--pe-contact-area-width, 40%);
}

.input-number {
  width: var(--pe-contact-number-width, 60%);
}
</style>